import React from 'react';
import { Row } from 'reactstrap';
import classNames from 'classnames';

import { Title } from 'components/typography';
import Feature from 'components/feature';
import SocialMediaLinks from 'components/socialMediaLinks';
import phoneIcon from 'assets/images/smartphone.svg';
import envelopeIcon from 'assets/images/envelope.svg';
import locationIcon from 'assets/images/location.svg';
import { slugify } from 'helpers';

import FooterLinksBlock from './FooterLinksBlock';
import {
  footer,
  footerHeader,
  footerContainer,
  socialMediaLinks,
  footerLinksContainer,
} from './scss/Footer.module.scss';

const Footer = () => {
  return (
    <footer className={classNames('footer', footer)}>
      <div className={footerContainer}>
        <div className={footerHeader}>
          <Title
            className="title"
            uppercased
            value="Afex Nigeria"
            fontStyle="regular"
            size="md"
          />
          <SocialMediaLinks className={socialMediaLinks} iconType="circular" />
        </div>

        <Row noGutters className={footerLinksContainer}>
          <FooterLinksBlock
            links={[
              { href: '/', value: 'AFEX at a Glance' },
              {
                href: `/about#${slugify('Mission & Vision')}`,
                value: 'Philosophy & Vision',
              },
              {
                href: `/market#${slugify('Products & Services')}`,
                value: 'Services & Products',
              },
              {
                href: `/about#${slugify('Leadership')}`,
                value: 'Executive Management',
              },
            ]}
          />
          <FooterLinksBlock
            links={[
              {
                href: `/market#${slugify('Data & Research')}`,
                value: 'Data & Research',
              },
              { href: '/market', value: 'Market View' },
              { href: '/updates', value: 'Updates' },
              { href: `/#${slugify('Social Media')}`, value: 'Social Media' },
            ]}
          />
          <Feature enabled={false}>
            <FooterLinksBlock
              links={[
                { href: '/', value: 'Open An Account' },
                { href: '/', value: 'Market Data' },
                { href: '/', value: 'Membership' },
                { href: '/', value: 'Membership Plans' },
              ]}
            />
          </Feature>
          <FooterLinksBlock
            links={[
              {
                href: 'tel:+09030001333',
                value: '+ 090 3000 1333',
                icon: phoneIcon,
              },
              {
                href: 'mailto:contactus@afexnigeria.com',
                value: 'contactus@afexnigeria.com',
                icon: envelopeIcon,
              },
              {
                href: '',
                value: `3rd Floor, Yobe Investment House, Plot 1332, Ralph Shodeinde Street,
          Beside Federal Ministry of Finance, Central Business District, Abuja`,
                icon: locationIcon,
              },
            ]}
          />
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
